





















































































































import Vue from 'vue'
import store, { state } from '@/store';
import syncStateWithStorage from '@/mixins/sync-state-with-storage.js';
import MODELS from '../../constants/models';
import { handleErrors, handleOptionalErrors } from '@/utils/notifications';
import { getEventIsSubmitForm } from '@/utils/eventShortcuts';
import displayEnterTip from '@/utils/displayEnterTip';
import client from '@/client.ts';
import { GQLLanguageType, GQLTranslationType } from "../../../types";
import CategoryAutoComplete from "@/components/CategoryAutoComplete.vue";
import TagSelect from "@/components/tags/TagSelect.vue";

  interface Field {
    readonly value: string,
    readonly text: string,
    readonly label: string,
    readonly languageId: string,
  }

export default Vue.extend({
  name: 'EditAssetForm',

  components: { CategoryAutoComplete, TagSelect },

  mixins: [syncStateWithStorage(['displayFields'])],

  props: {
    value: { type: Boolean, required: false, default: true },
    asset: { type: Object, required: true },
  },

  data: function data(): any {
    return {
      changedAsset: {} as Object,
      displayFields: [],
      addNewAssetOnSubmit: true,
      displaySettings: false,
    };
  },

  computed: {
    filteredDisplayFields(): Array<Field> {
      const fieldValues = this.displayFields.map((field: Field) => field.value);
      return this.fieldOptions
        .filter((field: Field) => fieldValues.includes(field.value));
    },

    fieldOptions(): any {
      return [
        ...state.project.languages.map((language: GQLLanguageType) => ({
          value: `language.${language.id}`,
          languageId: language.id,
          text: `${language.code}`,
          label: `${language.code} ${this.$t('assets.translation_label')}`,
        })),
      ]
    },

    hasValue(): any {
      return this.changedAsset.value || this.filteredDisplayFields
        .map((f: Field) => this.changedAsset[f.value])
        .filter((v?: string) => !!v)
        .length > 0;
    },
  },

  created() {
    this.createChangedAsset()
  },

  methods: {
    async editArchived(archived: boolean) {
      const { errors } = await client.updateAsset({ id: this.asset.id, archived });
      handleOptionalErrors(errors);
      this.close();
    },

    async archiveAsset() {
      this.editArchived(true);
    },

    async unarchiveAsset() {
      this.editArchived(false);
    },

    createChangedAsset: function createChangedAsset() {
      this.changedAsset.id = this.asset.id;
      this.changedAsset.value = this.asset.value;
      this.changedAsset.description = this.asset.description;
      this.changedAsset.tags = (this.asset.tags || []).map(({id}) => id);

      this.fieldOptions
        .filter(({ languageId }: { languageId: boolean }) => languageId)
        .forEach((field: Field) => {
          const translation = this.asset.translations.find((t: GQLTranslationType) => t.language && t.language.id === field.languageId);
          this.$set(this.changedAsset, field.value, (translation && translation.value) || "");
        });
    },

    imageForLanguage(languageId: string): string {
      return store.getLanguage(languageId).imageUrl || "";
    },

    handleTextAreaKeyPress(event: Event) {
      displayEnterTip();
      if (getEventIsSubmitForm(event)) {
        this.submit()
      }
    },

    async submit() {
      if(!this.hasValue) {
        return;
      }

      const { ok, asset, errors } = await client.updateAsset({
        archived: this.changedAsset.archived,
        description: this.changedAsset.description,
        id: this.changedAsset.id,
        value: this.changedAsset.value,
        tags: this.changedAsset.tags,
      });

      if (!ok || !(asset && asset.id)) {
        handleErrors(errors);
        return;
      }

      await Promise.all(
        this.displayFields
          .filter((field: Field) => field.languageId && typeof this.changedAsset[field.value] === "string")
          .map((field: Field) => client.updateOrCreateTranslation({
            value: this.changedAsset[field.value],
            language: field.languageId,
            id: (this.asset.translations.find((t: any) => t.language.id === field.languageId) || {}).id,
            asset: asset.id,
          }))
      );

      this.emptyAsset();
      this.close();
    },

    close() {
      this.$emit('close', false);
    },

    emptyAsset() {
      Object.keys(this.changedAsset).forEach((key) => {
        this.changedAsset[key] = MODELS.asset[key];
      });
    }
  },
});
